import { render, staticRenderFns } from "./FarmerSubGroupTable.vue?vue&type=template&id=4717da52&scoped=true&"
import script from "./FarmerSubGroupTable.vue?vue&type=script&lang=js&"
export * from "./FarmerSubGroupTable.vue?vue&type=script&lang=js&"
import style0 from "./FarmerSubGroupTable.vue?vue&type=style&index=0&id=4717da52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4717da52",
  null
  
)

export default component.exports